import { createSingleEntityStore, ngrxEvent } from '@core/ngrx-legacy';

import type { TellentTwoFactorAuthenticationSetup } from '../types';
import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<TellentTwoFactorAuthenticationSetup | null>()(
    EntityStoreKey.tellentTwoFactorAuthentication,
    {
      customActions: adapter => ({
        sendSmsCode: ngrxEvent<string>(),
        sendSmsCodeSuccess: ngrxEvent<void>(),
        sendSmsCodeFail: ngrxEvent<{ error: string[] }>(),

        enableSmsAuth: ngrxEvent<{ phoneNumber: string; code: string }>(),
        enableSmsAuthSuccess: ngrxEvent<void>(),
        enableSmsAuthFail: ngrxEvent<{ error: { errors: string[] } }>(),
        disableSmsAuth: ngrxEvent<string | null>(),
        disableSmsAuthSuccess: ngrxEvent<void>(),
        disableSmsAuthFail: ngrxEvent<{ error: { errors: string[] } }>(),
        enableAppAuth: ngrxEvent<string>(),
        enableAppAuthSuccess: ngrxEvent<void>(),
        enableAppAuthFail: ngrxEvent<{ error: { errors: string[] } }>(),
        disableAppAuth: ngrxEvent<string | null>(),
        disableAppAuthSuccess: ngrxEvent<void>(),
        disableAppAuthFail: ngrxEvent<{ error: { errors: string[] } }>(),
        // waiting for account recovery
        // dismissRecoveryInfobox: ngrxEvent<void>(),
        // dismissRecoveryInfoboxSuccess: ngrxEvent<void>(),
        // dismissRecoveryInfoboxFail: ngrxEvent<{ error: { error: string[] } }>(),
      }),
    },
  );

export {
  actions as TellentTwoFactorAuthenticationActions,
  reducer as TellentTwoFactorAuthenticationReducer,
  selectors as TellentTwoFactorAuthenticationSelectors,
  namespace as TellentTwoFactorAuthenticationNamespace,
};
